/* @flow */
/*global $, _gaq*/
/*eslint camelcase: [2, {properties: "never"}]*/
var ITEM_INFO = {

  highlightProductSelections: function () {
    "use strict";
    if (String($("#size_id").val()) === "0") {
      $("#sizes").addClass("alert alert-danger");
    }
    if (String($("#secondary_size_id").val()) === "0") {
      $("#secondary_sizes").addClass("alert alert-danger");
    }
    if (String($("#colour_id").val()) === "0") {
      $("#colours").addClass("alert alert-danger").css({ "margin-bottom": 0 });
    }
  },

  highlightSuitSelections: function () {
    "use strict";
    if (String($("#jacket_size_id").val()) === "0") {
      $("#jacket_sizes").addClass("alert alert-danger");
    }
    if (String($("#jacket_secondary_size_id").val()) === "0") {
      $("#jacket_secondary_sizes").addClass("alert alert-danger");
    }
    if (String($("#jacket_colour_id").val()) === "0") {
      $("#jacket_colours").addClass("alert alert-danger").css({ "margin-bottom": 0 });
    }

    if (String($("#trouser_size_id").val()) === "0") {
      $("#trouser_sizes").addClass("alert alert-danger");
    }
    if (String($("#trouser_secondary_size_id").val()) === "0") {
      $("#trouser_secondary_sizes").addClass("alert alert-danger");
    }
    if (String($("#trouser_colour_id").val()) === "0") {
      $("#trouser_colours").addClass("alert alert-danger").css({ "margin-bottom": 0 });
    }
  },

  messageOn: function () {
    "use strict";
    $(".inactive-buy").removeClass("btn-primary").addClass("btn-danger").text("Please Make Selections");

    if ($("#jacket_size_id").length) {
      this.highlightSuitSelections();
    } else {
      this.highlightProductSelections();
    }
  }
};

$(function () {
  "use strict";
  $("#product_info_form").on("click", ".inactive-buy", function (e) {
    e.preventDefault();
    e.stopPropagation();
    ITEM_INFO.messageOn();
    return false;
  });

  $(".measurement_sizechart").find("tbody").find("tr:lt(2)").find("th, td").css({
    "borderTop": "3px solid #9C806B"
  });

  //if the php has added a material swatch area to the page, enable swatch functionality
  if ($("#material_swatch_area").length) {
    $("[data-action=\"add-swatch\"]").on('click', function (e) {
      e.stopPropagation();
      var button = $(this);
      $.post("/ajax_add_swatch_to_basket.php", { product_id: $(this).attr("rel") }, function (data) {
        if (data.added === true) {
          button.removeClass("btn-primary").addClass("btn-success");
          button.val("View Basket");
          // button.unbind("click");
          button.on('click touchstart', function (e) {
            e.preventDefault();
            e.stopPropagation();
            location.href = "https://" + window.location.host + "/basket.php";
          });
          $("#swatch_goto_basket").css("display", "block");
          $("#header_basket_qty").html("(" + data.total_qty + ")");
          $(".basket-total").html(data.total);
        }
      }, "json");
    });
  }

  //measurement sizechart
  var toggleUnits = $(".toggle_units");
  var isImperial = toggleUnits.attr("data-imperial");
  $("body").on("click", ".toggle_units", function (e) {
    e.preventDefault();
    if (isImperial) {
      //$(".toggle_units").html("Convert to Inches");
      $(".toggle_units").css({ backgroundPosition: "0px -50px" });
      $(".inch").hide();
      $(".cm").show();
    } else {
      //$(".toggle_units").html("Convert to Centimetres");
      $(".toggle_units").css({ backgroundPosition: "0px 0px" });
      $(".inch").show();
      $(".cm").hide();
    }

    isImperial = !isImperial;
    toggleUnits.attr("data-imperial", isImperial);
  });
});
